(function ($) {
  init();
  function init() {
    // コレクションページ>コレクションにもっと見るボタン追加
    const interval = setInterval(() => {
      const $menuItem = $("#CollectionLinksForm").find(
        ".collections-menu__item"
      );

      if ($menuItem.length > 0) {
        clearInterval(interval);
        _collectionMenuAddMoreButton();
      }
    }, 100);
  }

  function _collectionMenuAddMoreButton() {
    const $menuItem = $("#CollectionLinksForm").find(".collections-menu__item");
    $menuItem.each(function () {
      const $target = $(this).find(".collections-menu__list");
      const $moreLinkPath = $(this).find(".js-reload-collection").val();
      $target.append(`<p class="anime-collection-more-links"><a href="${$moreLinkPath}">>>>もっと見る</a></p>`);
    });
  }
})(jQuery);
